import dynamic from 'next/dynamic'

import useModalStore from '@/store/slices/modal'

const CartModal = dynamic(() => import('@/modals/Cart'), { ssr: false })

function Modals() {
  const { name } = useModalStore((state) => state)

  if (name === 'cart') {
    return <CartModal />
  }

  return null
}

export default Modals
